class CalendarInput {
    timeItemClass = '.time-item';

    static init($context = null){

        let selector = '[data-input="calendar"]';
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if($(element).data('calendar_input_instance')) return;
            $(element).data('calendar_input_instance', new CalendarInput(element))
        });


        // if(!CalendarType.instance){
        //     CalendarType.instance = new CalendarType();
        // }
    }

    constructor(element) {
        this.element = element
        this.$element = $(element);
        this.$dpElement = this.$element.find('.calendar-date-selection-inline');
        this.$tpElement = this.$element.find('.calendar-time-selection-inline');
        this.$dateInput = this.$element.find('input[name$="[date]"]')
        this.$timesInput = this.$element.find('input[name$="[times]"]')
        this.$quantityInput = this.$element.find('input[name$="[quantity]"]')
        this.$interval = this.$dpElement.data('calendar-interval');
        this.$urgentCheckbox = $('input[type="checkbox"][name*="[Urgent]"]');

        this.initDatepicker();
        this.initEvents();

        this.updateSelectedTimes();
    }

    initDatepicker() {
        let lang = document.documentElement.getAttribute('lang');
        let minDate = this.$dpElement.data('calendar-min-date');
        let weekDaysOff = this.$dpElement.data('calendar-week-days-off');
        let defaultDate = this.$dateInput.val();

        let dpOptions = {
            inline: true,
            changeYear: false,
            minDate: minDate,
            defaultDate: defaultDate,
            locale: flatpickr.l10ns[lang] ? flatpickr.l10ns[lang] : flatpickr.l10ns.default,
            disable: [
                function(date) {
                    return !!weekDaysOff.includes(date.getDay());
                },
                // Disable specific dates
                //"2025-01-01",
            ],
            onChange: function(selectedDates, dateStr) {
                this.setTimes([])
                this.loadTimePicker(dateStr)
            }.bind(this),
            onReady: function (selectedDates, dateStr) {
                // let currentValue = that.getSelectedValues();
                //
                // if(currentValue.date == null){
                //     currentValue.date = dateStr;
                //     that.setSelectedValues(currentValue);
                // }
            }
        };

        flatpickr(this.$dpElement, dpOptions);

        if(defaultDate){
            this.loadTimePicker(defaultDate)
        }
    }

    loadTimePicker(date) {
        let that = this;
        let urgent = this.getUrgentValue();

        $.get(window.location.origin+'/api/attributes/calendar_times', {
            date: date,
            serviceField: this.element.dataset.serviceField,
            urgent: urgent
        }).done(function (result){
            this.$tpElement.html(result);
            this.$tpElement.find(this.timeItemClass).on('click', function (e){
                this.onTimeToggle($(e.currentTarget));
            }.bind(this))
            this.updateSelectedTimes()
        }.bind(this));

        this.$timesInput.on('change', function (){
            this.updateSelectedTimes()
        }.bind(this))
    }

    getUrgentValue() {
        return this.$urgentCheckbox.length > 0 ? this.$urgentCheckbox.is(':checked') : false;
    }

    initEvents() {
        let that = this;

        this.$urgentCheckbox.on('change', function() {
            let currentDate = that.$dateInput.val();
            if(currentDate) {
                that.setTimes([]);
                that.loadTimePicker(currentDate);
            }
        });
    }

    onTimeToggle($item){
        if($item.hasClass('active')){
            this.setTimeItemInactive($item);
        }else{
            this.setTimeItemActive($item);
        }

        this.updateQuantity();
        this.disableEnableTimeItems();
    }

    setTimeItemActive($item) {
        let selectedTime = this.getSelectedTimes();
        selectedTime.push($item.val())
        this.setTimes(selectedTime)
    }

    setTimeItemInactive($item) {
        let selectedTime = this.getSelectedTimes();
        let value = $item.val();
        const index = selectedTime.indexOf(value);
        if (index > -1) { // only splice array when item is found
            selectedTime.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.setTimes(selectedTime)
    }

    enableTimeItem($item) {
        $item.removeClass('disabled')
    }

    disableTimeItem($item) {
        $item.addClass('disabled')
    }

    disableEnableTimeItems() {
        let selectedTimes = this.getSelectedTimes();
        let that = this;

        if (selectedTimes.length > 0) {
            // Determine the first and last selected times
            let firstSelected = selectedTimes[0];
            let lastSelected = selectedTimes[selectedTimes.length - 1];

            let firstSelectedTime = that.parseTime(selectedTimes[0]);
            let lastSelectedTime = that.parseTime(selectedTimes[selectedTimes.length - 1]);

            $(this.timeItemClass).each(function (index, item) {
                let $item = $(item);
                let itemVal = $item.val();

                // Disable all middle items (between the first and last selected)
                if (selectedTimes.includes(itemVal)) {
                    if (itemVal === firstSelected || itemVal === lastSelected) {
                        // Enable only the first and last selected items
                        that.enableTimeItem($item);
                    } else {
                        // Disable deselection of middle items
                        that.disableTimeItem($item);
                    }
                } else {
                    let itemTime = that.parseTime(itemVal);

                    // Enable items that are adjacent to the first or last selected items
                    if (itemVal === $(that.timeItemClass + '[value="' + firstSelected + '"]').prev().val()) {
                        // Enable/Disable time items based on the gap (30 minutes in this case)
                        if (Math.abs(itemTime - firstSelectedTime) > that.$interval) {
                            that.disableTimeItem($item);
                        } else {
                            that.enableTimeItem($item);
                        }
                    } else if (itemVal === $(that.timeItemClass + '[value="' + lastSelected + '"]').next().val()) {
                        // Enable/Disable time items based on the gap (30 minutes in this case)
                        if (Math.abs(itemTime - lastSelectedTime) > that.$interval) {
                            that.disableTimeItem($item);
                        } else {
                            that.enableTimeItem($item);
                        }
                    } else {
                        // Disable all other items
                        that.disableTimeItem($item);
                    }
                }
            });
        } else {
            // Enable all items if no time items are selected
            $(this.timeItemClass).each(function (index, item) {
                let $item = $(item);
                that.enableTimeItem($item);
            });
        }
    }

    parseTime(time) {
        let timeParts = time.split(":");
        let hours = parseInt(timeParts[0]);
        let minutes = parseInt(timeParts[1]);

        return (hours * 60) + minutes;
    }

    setQuantity(quantity){
        this.$quantityInput.val(quantity)
    }

    updateQuantity() {
        let selectedTimes = this.getSelectedTimes();
        let quantity = this.$interval * selectedTimes.length;

        this.setQuantity(quantity);
    }

    getQuantity() {
        return Number(this.$quantityInput.val());
    }

    getSelectedTimes() {
        let v = this.$timesInput.val()
        if(v){
            return v.split(',').sort()
        }else{
            return [];
        }

    }
    setTimes(times) {
        this.$timesInput.val(times.join(',')).change()
    }
    updateSelectedTimes() {
        this.$element.find(`${this.timeItemClass}.active`).removeClass('active')
        this.getSelectedTimes().forEach(function (value){
            this.$element.find(`${this.timeItemClass}[value="${value}"]`).addClass('active')
        }.bind(this))

    }
}

CalendarInput.init();
//node modules support
module.exports = CalendarInput;